export default {
  // Etiquetas de pestañas
  notificationCenter_00001: "Alerts",
  notificationCenter_00002: "Maintenance",
  
  // Encabezados de tabla
  notificationCenter_00003: "Time Sent",
  notificationCenter_00004: "SN",
  notificationCenter_00005: "Station",
  notificationCenter_00006: "Error Code",
  notificationCenter_00007: "Recipient",
  notificationCenter_00008: "Status",
  
  // Valores de estado
  notificationCenter_00009: "Pending",
  notificationCenter_00010: "Sent",
  notificationCenter_00011: "Failed",
  
  // Botones y acciones
  notificationCenter_00012: "View",
  notificationCenter_00013: "Search",
  
  // Placeholders de búsqueda
  notificationCenter_00014: "Enter Device Name or SN",
  notificationCenter_00015: "All Station",
  
  // Relacionado con diálogo
  notificationCenter_00016: "Email Notification",
  notificationCenter_00017: "Time Sent:",
  notificationCenter_00018: "Type:",
  notificationCenter_00019: "Fault Alert",
  notificationCenter_00020: "SN:",
  notificationCenter_00021: "Station:",
  notificationCenter_00022: "Error Code:",
  notificationCenter_00023: "Recipients:",
  notificationCenter_00024: "Email Content",
  notificationCenter_00025: "Close",
};
